<div class="featurePanel details" [class.expanded]="(selectedServiceConnection)">
  <button (click)="closeRightPanel()" class="float-right btn-close my-1 d-block" title="Close">
    <h2 class="carouselTitle">Service Connections</h2>
    <i class="far fa-chevron-right"></i>
  </button>
  <div class="details-scroll" [style.height.px]="scrollHeight">
    <div class="address-title">{{selectedServiceConnection.address}}
      <button class="btn btn-link float-right" (click)="openSvcConnReport()">
        <i class="far fa-print"></i>
      </button>
    </div>

    <div class="panels" id="panels">
      <div class="panel">
        @if (selectedServiceConnection && selectedServiceConnection.sanitaryConnections) {
          <div>
            @for (conn of selectedServiceConnection.sanitaryConnections; track conn; let i = $index) {
              <div>
                <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse"
                  attr.data-bs-target="#SanitaryConnection{{i+1}}" aria-expanded="false"
                  attr.aria-controls="SanitaryConnection{{i+1}}"
                  (click)="selectConnection(selectSanitaryConnectionLayer(conn), conn.objectId, isCollapsed($event))">
                  <h4 class="float-left">Sanitary Connection #{{i+1}}</h4>
                  <i class="far fa-chevron-down float-right fa-xs"></i>
                  <i class="far fa-chevron-up float-right fa-xs"></i>
                </button>
                <div id="SanitaryConnection{{i+1}}" class="collapse" data-parent="#panels">
                  <div class="key-pair">
                    <span class="label">Location</span>
                    <span>{{sanitize(conn.location)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Size</span>
                    <span>{{sanitize(conn.size,'mm')}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Length</span>
                    <span>{{sanitize(conn.length) | number : '1.2-2'}}m</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Material</span>
                    <span>{{sanitize(conn.material)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Ownership</span>
                    <span>{{sanitize(conn.owner)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Installed</span>
                    <span>{{sanitize(conn.year)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Prelined Material</span>
                    <span>{{sanitize(conn.prelinedMaterial)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Prelined Year</span>
                    <span>{{sanitize(conn.prelinedYear)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped</span>
                    <span>{{sanitize(conn.capped)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped Date</span>
                    <span>{{sanitize(conn.cappedDate, '', true)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Grouted</span>
                    <span>{{sanitize(conn.grouted)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Grout Date</span>
                    <span>{{sanitize(conn.groutDate, '', true)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Drawing</span>
                    @if (!isNullOrEmpty(conn.drawing)) {
                      <button (click)="openDrawing(conn.drawing)"
                        class="no-select btn btn-link text-start">
                      {{conn.drawing}}</button>
                    }
                    @if (isNullOrEmpty(conn.drawing)) {
                      <span>{{sanitize(conn.drawing)}}</span>
                    }
                  </div>
                  <div class="key-pair">
                    <span class="label">Invert Elev</span>
                    <span>{{sanitize(conn.invertElev,'m')}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Asset ID</span>
                    <span>{{sanitize(conn.assetId)}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="panel">
        @if (selectedServiceConnection && selectedServiceConnection.stormConnections) {
          <div>
            @for (conn of selectedServiceConnection.stormConnections; track conn; let i = $index) {
              <div>
                <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse"
                  attr.data-bs-target="#StormConnection{{i+1}}" aria-expanded="false"
                  attr.aria-controls="StormConnection{{i+1}}"
                  (click)="selectConnection(selectStormConnectionLayer(conn), conn.objectId, isCollapsed($event))">
                  <h4 class="float-left">Storm Connection #{{i+1}}</h4>
                  <i class="far fa-chevron-down float-right fa-xs"></i>
                  <i class="far fa-chevron-up float-right  fa-xs"></i>
                </button>
                <div id="StormConnection{{i+1}}" class="collapse" data-parent="#panels">
                  <div class="key-pair">
                    <span class="label">Location</span>
                    <span>{{sanitize(conn.location)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Size</span>
                    <span>{{sanitize(conn.size,'mm')}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Length</span>
                    <span>{{sanitize(conn.length) | number : '1.2-2'}}m</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Material</span>
                    <span>{{sanitize(conn.material)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Ownership</span>
                    <span>{{sanitize(conn.owner)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Installed</span>
                    <span>{{sanitize(conn.year)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped</span>
                    <span>{{sanitize(conn.capped)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped Date</span>
                    <span>{{sanitize(conn.cappedDate, '', true)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Drawing</span>
                    @if (!isNullOrEmpty(conn.drawing)) {
                      <button (click)="openDrawing(conn.drawing)"
                        class="no-select btn btn-link text-start">
                      {{conn.drawing}}</button>
                    }
                    @if (isNullOrEmpty(conn.drawing)) {
                      <span>{{sanitize(conn.drawing)}}</span>
                    }
                  </div>
                  <div class="key-pair">
                    <span class="label">Invert Elev</span>
                    <span>{{sanitize(conn.invertElev,'m')}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Asset ID</span>
                    <span>{{sanitize(conn.assetId)}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="panel">
        @if (selectedServiceConnection && selectedServiceConnection.waterConnections) {
          <div>
            @for (conn of selectedServiceConnection.waterConnections; track conn; let i = $index) {
              <div>
                <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse"
                  attr.data-bs-target="#WaterConnection{{i+1}}" aria-expanded="false"
                  attr.aria-controls="WaterConnection{{i+1}}"
                  (click)="selectConnection(selectWaterConnectionLayer(conn), conn.objectId, isCollapsed($event))">
                  <h4 class="float-left">Water Connection #{{i+1}}</h4>
                  <i class="far fa-chevron-down float-right fa-xs"></i>
                  <i class="far fa-chevron-up float-right  fa-xs"></i>
                </button>
                <div id="WaterConnection{{i+1}}" class="collapse" data-parent="#panels">
                  <div class="key-pair">
                    <span class="label">Location</span>
                    <span>{{sanitize(conn.location)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Size</span>
                    <span>{{sanitize(conn.size,'mm')}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Length</span>
                    <span>{{sanitize(conn.length) | number : '1.2-2'}}m</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Material</span>
                    <span>{{sanitize(conn.material)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Ownership</span>
                    <span>{{sanitize(conn.owner)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Installed</span>
                    <span>{{sanitize(conn.year)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped</span>
                    <span>{{sanitize(conn.capped)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Capped Date</span>
                    <span>{{sanitize(conn.cappedDate, '', true)}}</span>
                  </div>
                  <div class="key-pair">
                    <span class="label">Drawing</span>
                    @if (!isNullOrEmpty(conn.drawing)) {
                      <button (click)="openDrawing(conn.drawing)"
                        class="no-select btn btn-link text-start">
                      {{conn.drawing}}</button>
                    }
                    @if (isNullOrEmpty(conn.drawing)) {
                      <span>{{sanitize(conn.drawing)}}</span>
                    }
                  </div>
                  <div class="key-pair">
                    <span class="label">Asset ID</span>
                    <span>{{sanitize(conn.assetId)}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>